module.exports = __webpack_public_path__ + "static/media/clear.3dc88b02.svg";